<template>
  <div class="device_simcards">
    <div
      v-for="(simcard,key) in sorting_simcards"
      :key="key"
      class="simcard"
      :class="{'our_sim': simcard.simcard_profile?.id}"
      :title="simcard.imsi"
    >
      <p class="simcard_info">
        <span class="simcard_status" :style=" simcard.status? 'background-color: ' + simcard.status: 'background-color: #000'"></span>
        <span class="simcard_mno">{{ simcard.mno }} </span>
        <span class="simcard_slot" v-if="simcard.slot">({{ simcard.slot }})</span>
      </p>

      <p class="simcard_badges">
        <span v-if="simcard.simcard_profile?.esim" class="badge"
            :class="global_status_color(simcard.simcard_profile?.status)" v-html="'ESIM'"
        />
        <span v-if="simcard.simcard_profile?.apn" class="badge"
              :class="global_status_color(simcard.simcard_profile?.status)" v-html="'APN'"
        />
        <span v-if="simcard.simcard_profile?.id && simcard.simcard_profile?.esim === false && simcard.simcard_profile?.apn === false" class="badge empty"
              :class="global_status_color(simcard.simcard_profile?.status)"
        />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceSimcards',
  props: {
    simcards: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    sorting_simcards() {
      return [...(this.simcards || [])].sort((a, b) => a.slot > b.slot ? 1 : -1)
    }
  }
}
</script>

<style lang="scss" scoped>
.device_simcards{
  .simcard{
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 0;

    a,p{
      margin: 0;
      font-size: 10px;
    }
    &.our_sim{
      background-color: #41b88330;
    }
    &_info{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 4px;
    }
    &_status{
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
    &_badges{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 4px;
    }
    .badge{
      display: block;
      font-size: 10px;
      padding: 3px;
      width: 30px;
      text-align: center;

      &.empty{
        height: 16px;
      }
    }
  }
}
</style>
